import React, { useEffect, Fragment, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Footer from './common/Footer'
import Header from './common/Header';
import Preloader from '../components/common/Preloader';
import SlidersIndex from './sliders/SlidersIndex';
import SwipperIndex from './sliders/SwipperIndex';
import FrontendPageSEO from '../components/common/FrontendPageSEO';
import Sliders1_Index from './sliders/Sliders1_Index';
import useFrontendPageContent from '../components/common/useFrontendPageContent';
import DynamicSectionTitle from '../components/common/DynamicSectionTitle';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../index.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

const hotelSearchStyles = `
.home-hotel-search .search-container { position: relative; width: 100%; }
.home-hotel-search .suggestions-dropdown { position: absolute; left: 12px; right: 0; width: auto; box-sizing: border-box; background-color: white; border: 1px solid #ddd; border-top: none; border-radius: 10px 0 8px 8px; z-index: 9999; max-height: 300px; overflow-y: auto; text-align: left; box-shadow: 0 4px 6px rgba(0,0,0,0.1); }
.home-hotel-search .suggestion-item { padding: 12px 20px; cursor: pointer; border-bottom: 1px solid #eee; }
.home-hotel-search .suggestion-item:last-child { border-bottom: none; }
.home-hotel-search .suggestion-item:hover { background-color: #f5f5f5; }
.home-hotel-search .suggestion-item strong { color: #333; }
.home-hotel-search .suggestion-item small { color: #888; margin-left: 8px; text-transform: capitalize; }
@media (max-width: 767px) {
  .home-hotel-search .suggestions-dropdown { top: 50px; }
}
`;

function Index() {
  const navigate = useNavigate();
  const { pageContent, getSection, isSectionActive, loading } = useFrontendPageContent('home');
  const [searchQuery, setSearchQuery] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [isSuggestionsLoading, setIsSuggestionsLoading] = useState(false);

  useEffect(() => {
    if (searchQuery.trim().length < 2) {
      setSuggestions([]);
      setIsSuggestionsLoading(false);
      return;
    }

    const debounceTimer = setTimeout(async () => {
      setIsSuggestionsLoading(true);
      try {
        const response = await axios.get(`${API_BASE_URL}/search`, {
          params: { q: searchQuery.trim() },
        });
        const searchResults = Array.isArray(response.data) ? response.data : [];
        const seen = new Set();
        setSuggestions(searchResults.filter((item) => {
          const key = `${item.type}|${String(item.name || '').trim().toLowerCase()}|${String(item.city || '').trim().toLowerCase()}`;
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        }));
      } catch (error) {
        console.error('Failed to fetch search suggestions:', error);
        setSuggestions([]);
      } finally {
        setIsSuggestionsLoading(false);
      }
    }, 300);

    return () => clearTimeout(debounceTimer);
  }, [searchQuery]);

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    const query = searchQuery.trim();
    if (query) {
      setSuggestions([]);
      navigate(`/search?q=${encodeURIComponent(query)}`);
    }
  };

  const slugify = (value) => String(value || '')
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-')
    .replace(/^-+|-+$/g, '');

  const generateHotelSlug = (hotel) => {
    const name = slugify(hotel?.name || hotel?.hotel_name);
    const city = slugify(hotel?.city);
    const price = Math.round(hotel?.offer_price || hotel?.hotel_price || hotel?.price || 0);
    return [name, city, price || null, hotel?.id].filter(Boolean).join('-');
  };

  const generateListingSlug = (item) => {
    const price = Math.round(item?.offer_price || item?.price || 0);
    return [slugify(item?.name), slugify(item?.city), price || null, item?.id].filter(Boolean).join('-');
  };

  const getSuggestionUrl = (item) => {
    const slug = generateListingSlug(item);
    if (item.type === 'holiday') return `/holiday-details/${slug}`;
    if (item.type === 'hotel') return `/hotel-details/${generateHotelSlug(item)}`;
    if (item.type === 'yatra') return `/yatra-details/${slug}`;
    if (item.type === 'doctor' || item.type === 'hospital') return `/medical-details/${item.type}/${slug}`;
    if (item.type === 'cab') return `/cabs/search?q=${encodeURIComponent(item.name || searchQuery)}`;
    return `/search?q=${encodeURIComponent(item.name || searchQuery)}`;
  };

  const handleSuggestionClick = (suggestion) => {
    setSearchQuery(suggestion.name || '');
    setSuggestions([]);
    navigate(getSuggestionUrl(suggestion));
  };
  const heroSection = getSection('hero', {
    title: 'Discover the World with Us',
    subtitle: 'Unforgettable Tours, Tailored Holidays, and Hassle-Free Travel Experiences Await You!',
    background_image: 'assets/img/home/1.jpg',
    Items: [
      { title: 'Family Retreat', image_url: 'assets/img/tours/theme/family.png' },
      { title: 'Pilgrimage', image_url: 'assets/img/tours/theme/pilgrimage.png' },
      { title: 'Honeymoon', image_url: 'assets/img/tours/theme/honeymoon.png' },
      { title: 'Adventure', image_url: 'assets/img/tours/theme/adventure.png' },
      { title: 'Beach', image_url: 'assets/img/tours/theme/beach.png' },
    ],
  });
  const travelSolutions = getSection('travel_solutions', {
    title: 'Solutions for Every Journey',
    title_highlight: 'Complete Travel',
    Items: [
      { title: 'Hotels', subtitle: 'Explore', image_url: 'assets/img/home/hotel.png', link_url: '/hotel-list', button_text: 'Book Now' },
      { title: 'Car Rentals', subtitle: 'Book Your', image_url: 'assets/img/home/car-rental.png', link_url: '/cabs', button_text: 'Book Now' },
      { title: 'Destinations', subtitle: 'Explore', image_url: 'assets/img/home/holiday.png', link_url: '/holidays-list', button_text: 'Discover More' },
      { title: 'Tirth Yatra', subtitle: 'Explore', image_url: 'assets/img/home/tirth-yatra.png', link_url: '/tirthyatra', button_text: 'Discover More' },
    ],
  });
  const exclusiveDeals = getSection('exclusive_deals', {
    title: 'Deals and Savings',
    title_highlight: 'Unlock Exclusive',
  });
  const stayLocations = getSection('stay_locations', {
    title: 'in Dream Locations',
    title_highlight: 'Find Your Stay',
  });
  const holidayThemes = getSection('holiday_themes', {
    title: 'Holidays By Theme',
    title_highlight: 'Explore',
    button_text: 'View All Offers',
    button_link: '/holidays-list',
    Items: [
      { title: 'Family', image_url: 'assets/img/tours/theme/family.png' },
      { title: 'Pilgrimage', image_url: 'assets/img/tours/theme/pilgrimage.png' },
      { title: 'Honeymoon', image_url: 'assets/img/tours/theme/honeymoon.png' },
      { title: 'Adventure', image_url: 'assets/img/tours/theme/adventure.png' },
      { title: 'Beach', image_url: 'assets/img/tours/theme/beach.png' },
      { title: 'Luxury', image_url: 'assets/img/tours/theme/luxury.png' },
      { title: 'Safari Trails', image_url: 'assets/img/tours/theme/safari-trails.png' },
      { title: 'Weekend', image_url: 'assets/img/tours/theme/weekend.png' },
      { title: 'Youth', image_url: 'assets/img/tours/theme/youth-holidays.png' },
      { title: 'Vacation', image_url: 'assets/img/tours/theme/family.png' },
    ],
  });
  const homeBanners = getSection('home_banners', {
    Items: [
      { image_url: 'assets/img/home/banner-1.png', title: 'Primary Banner' },
      { image_url: 'assets/img/home/banner-2.png', title: 'Secondary Banner' },
    ],
  });
  const homeOutstationCabs = getSection('outstation_cabs', {
    title: 'City To City-Outstation Cabs',
    subtitle: 'Enjoy Best Price Guarantee, professional services, timely pick-up & drop-off and more!',
  });

  const renderOutstationCabCard = (item, className = '', cardStyle = {}) => {
    const destinationCity = String(item?.title || '').trim();
    const searchParams = new URLSearchParams({
      from: 'Mumbai',
      to: destinationCity,
    });
    const linkUrl = `/cabs/search?${searchParams.toString()}`;

    return (
      <a
        className={className}
        href={linkUrl}
        aria-label={`View outstation cabs from Mumbai to ${destinationCity || 'this city'}`}
        style={{ color: 'inherit', textDecoration: 'none', ...cardStyle }}
      >
        <div className="mgdestn"><img src={item.image_url} alt={item.title || ''} /></div>
        <div className="_pckgdscrptn">
          <h5 className="state-name-h5">{item.title}</h5>
          <div className="htlnking">{item.description}</div>
        </div>
      </a>
    );
  };
  const whyBookItems = [
    {
      title: 'Easy Booking',
      description: 'We offer easy and convenient flight bookings with attractive offers.',
      image_url: 'assets/img/home/why-us/easy-booking.svg',
    },
    {
      title: 'Lowest Price',
      description: 'We ensure low rates on hotel reservation, holiday packages and on flight tickets.',
      image_url: 'assets/img/home/why-us/lowest-booking.svg',
    },
    {
      title: 'Exciting Deals',
      description: 'Enjoy exciting deals on flights, hotels, buses, car rental and tour packages.',
      image_url: 'assets/img/home/why-us/exc-deal.svg',
    },
    {
      title: '24/7 Support',
      description: 'Our dedicated support team is available around the clock to assist you',
      image_url: 'assets/img/home/why-us/support.svg',
    },
  ];
  function updateClassBasedOnScreenSize() {
    const element = document.querySelector(".complete_travel.title.text-center h3"); // Ensure targeting the correct h3 element

    if (!element) return;

    if (window.innerWidth >= 1024) {
      element.classList.remove("pb-3");
      element.classList.add("pb-5");
    } else {
      element.classList.remove("pb-5");
      element.classList.add("pb-3");
    }


    // Handling the popular-state class
    const popularStateElement = document.querySelector(".banner-sec");
    if (popularStateElement) {
      if (window.innerWidth >= 1024) {
        popularStateElement.classList.add("pb-5");
      } else {
        popularStateElement.classList.remove("pb-5");
      }
    } else {
      console.warn("Popular-state element not found! Check your class names.");
    }

    const popularStateElement_1 = document.querySelector(".banner-index");
    if (popularStateElement_1) {
      if (window.innerWidth >= 1024) {

        popularStateElement_1.classList.add("pb-5");
      } else {

        popularStateElement_1.classList.remove("pb-5");
      }
    } else {
      console.warn("Popular-state element not found! Check your class names.");
    }

    const exploreHolidays = document.querySelector(".explore_holidays.title.text-center h3"); // Ensure targeting the correct h3 element

    if (!exploreHolidays) return;

    if (exploreHolidays) {
      if (window.innerWidth >= 1024) {
        exploreHolidays.classList.remove("pb-3"); // Remove pb-5 for mobile
        exploreHolidays.classList.add("pb-5"); // Add pb-3 for mobile screens
      } else {
        exploreHolidays.classList.remove("pb-5");
        exploreHolidays.classList.add("pb-3");

      }
    } else {
      console.log("explore_holidays.title.text-center h3 element not found")
    }

    const holidays_theme = document.querySelector(".banner-holidays-theme");
    if (holidays_theme) {
      if (window.innerWidth >= 1024) {

        holidays_theme.classList.add("pb-2");
      } else {

        holidays_theme.classList.remove("pb-2");
      }
    } else {
      console.warn("Popular-state element not found! Check your class names.");
    }

    const whyBook = document.querySelector(".why-book.title.text-center h3"); // Ensure targeting the correct h3 element
    if (!whyBook) return;

    if (whyBook) {
      if (window.innerWidth >= 1024) {
        whyBook.classList.remove("pb-3"); // Remove pb-5 for mobile
        whyBook.classList.add("pb-5"); // Add pb-3 for mobile screens
      } else {
        whyBook.classList.remove("pb-5");
        whyBook.classList.add("pb-3");

      }
    } else {
      console.log("explore_holidays.title.text-center h3 element not found")
    }

    const whyBook_1 = document.querySelector(".why-book-1"); // Ensure targeting the correct h3 element
    if (!whyBook_1) return;

    if (whyBook_1) {
      if (window.innerWidth >= 1024) {
        whyBook_1.classList.add("mb-5");
      } else {

        whyBook_1.classList.remove("mb-5");

      }
    } else {
      console.log("explore_holidays.title.text-center h3 element not found")
    }
  }

  // Run on page load and when resizing
  window.addEventListener("load", updateClassBasedOnScreenSize);
  window.addEventListener("resize", updateClassBasedOnScreenSize);


  if (loading || !pageContent) {
    return <Preloader />;
  }

  return (
    <div>
      <Fragment>
        <style>{hotelSearchStyles}</style>
        <FrontendPageSEO
          page={pageContent}
          fallbackTitle="Mangoloops | Discover the World with Us"
          fallbackDescription="Unforgettable Tours, Tailored Holidays, and Hassle-Free Travel Experiences with Mangoloops. Book hotels, cabs, and holiday packages today."
          fallbackSlug="/"
        />
        <Header />
        <main id="content">
          {isSectionActive('hero') && (
          <div className="banner-content hero-block hero-v1  bg-img-hero-bottom gradient-overlay-half-black-gradient text-center z-index-2 div-index" style={{ backgroundImage: `url(${heroSection.background_image})` }}>
            <div className="container pb-4 pb-0 pt-5">
              <div className="row justify-content-md-center">
                <div className="pt-3">
                  <h1 className="font-size-60 font-size-xs-30 text-white font-weight-bold">
                    {heroSection.title}
                  </h1>
                  <p className="font-size-20 font-weight-normal text-white">
                    {heroSection.subtitle}
                  </p>

                  {/* <div className="row justify-content-center pt-5">
                    {(heroSection.Items || []).map((item, index) => (
                      <div className="col-lg-2 holiday-theme-sec mobile-width-33" key={`${item.title}-${index}`}>
                        <div className="">
                          <img src={item.image_url} width="100%" alt={item.title} />
                          <h5 className="holiday-theme-name text-white">{item.title}</h5>
                        </div>
                      </div>
                    ))}
                  </div> */}

                  <div className="row justify-content-center pt-4 home-hotel-search">
                    <div className="col-lg-8">
                      <form className="form-container search-input-form" onSubmit={handleSearchSubmit}>
                        <div className="search-container">
                          <span><i className="fa fa-search search-icon"></i></span>
                          <input
                            type="text"
                            placeholder="Find Your Perfect Trip"
                            className="search-input"
                            value={searchQuery}
                            onChange={(event) => setSearchQuery(event.target.value)}
                            autoComplete="off"
                          />
                          <button type="submit" className="search-button">Search</button>
                          {isSuggestionsLoading && (
                            <div className="suggestions-dropdown">
                              <div className="suggestion-item">Loading...</div>
                            </div>
                          )}
                          {!isSuggestionsLoading && suggestions.length > 0 && (
                            <div className="suggestions-dropdown">
                              {suggestions.map((item, index) => (
                                <div
                                  key={`${item.type}-${item.id || index}`}
                                  className="suggestion-item"
                                  onMouseDown={() => handleSuggestionClick(item)}
                                >
                                  <strong>{item.name}</strong>
                                  <small>— {item.type}{item.city ? ` · ${item.city}` : ''}</small>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          )}

          {isSectionActive('exclusive_deals') && <SlidersIndex section={exclusiveDeals} />}

          {isSectionActive('travel_solutions') && (
          <div className="popular-state">
            <div className="container">
              <div className="complete_travel title text-center ">
                <DynamicSectionTitle section={travelSolutions} className="pb-5" />

                {travelSolutions?.is_slider ? (
                  <Slider 
                    slidesToShow={parseInt(travelSolutions.items_per_view) || 4} 
                    slidesToScroll={1} 
                    autoplay={true} 
                    arrows={true} 
                    responsive={[{breakpoint: 1024, settings: {slidesToShow: 3}}, {breakpoint: 768, settings: {slidesToShow: 2}}]}
                  >
                    {(travelSolutions.Items || []).map((item, index) => (
                      <div className="px-2" key={`${item.title}-${index}`}>
                        <div className={`services-we-offer services-style-${(index % 4) + 1}`}>
                          <div className="text">
                            <h6 className="services-h6-explore">{item.subtitle}</h6>
                            <h4 className="services-h4">{item.title}</h4>
                            <a className="btn btn-outline-dark border-width-2 font-weight-normal transition-3d-hover services-btn" href={item.link_url || '#'} target='_blank' rel="noreferrer">{item.button_text || 'Book Now'}</a>
                          </div>
                          <div className="icon">
                            <img src={item.image_url} className="services-img" alt={item.title} />
                          </div>
                        </div>
                      </div>
                    ))}
                  </Slider>
                ) : (
                  <div className="row index-page">
                    {(travelSolutions.Items || []).map((item, index) => {
                      const pv = parseInt(travelSolutions.items_per_view) || 4;
                      const cw = 100 / pv;
                      return (
                      <div className="mobile-width-50" style={{ flex: `0 0 ${cw}%`, maxWidth: `${cw}%`, padding: '0 15px' }} key={`${item.title}-${index}`}>
                        <div className={`services-we-offer services-style-${(index % 4) + 1}`}>
                          <div className="text">
                            <h6 className="services-h6-explore">{item.subtitle}</h6>
                            <h4 className="services-h4">{item.title}</h4>
                            <a className="btn btn-outline-dark border-width-2 font-weight-normal transition-3d-hover services-btn" href={item.link_url || '#'} target='_blank' rel="noreferrer">{item.button_text || 'Book Now'}</a>
                          </div>
                          <div className="icon">
                            <img src={item.image_url} className="services-img" alt={item.title} />
                          </div>
                        </div>
                      </div>
                    )})}
                  </div>
                )}

              </div>
            </div>
          </div>
          )}


          {/* <SwipperIndex /> */}

          {isSectionActive('stay_locations') && <Sliders1_Index section={stayLocations} />}
          
          {isSectionActive('home_banners') && (
          <div className="banner-sec">
            <div className="container">
              <div className="banner-index row pb-5">

                <div className="col-lg-9 pb-4">
                  <img className="br-12" src={homeBanners.Items?.[0]?.image_url || 'assets/img/home/banner11.png'} alt={homeBanners.Items?.[0]?.title || ''} width="100%" />
                </div>

                <div className="col-lg-3 pb-4">
                  <img className="br-12" src={homeBanners.Items?.[1]?.image_url || 'assets/img/home/banner21.png'} alt={homeBanners.Items?.[1]?.title || ''} width="100%" />
                </div>

              </div>
            </div>
          </div>
          )}

          {isSectionActive('holiday_themes') && (
          <div className="popular-state banner-holidays-theme">
            <div className="container">
              <div className="explore_holidays title text-center ">
                <DynamicSectionTitle section={holidayThemes} className="pb-5" />

                {holidayThemes?.is_slider ? (
                  <div style={{ padding: '0 20px' }}>
                  <Slider 
                    slidesToShow={parseInt(holidayThemes.items_per_view) || 5} 
                    slidesToScroll={1} 
                    autoplay={true} 
                    arrows={true}
                    responsive={[{breakpoint: 1024, settings: {slidesToShow: 4}}, {breakpoint: 768, settings: {slidesToShow: 2}}]}
                  >
                    {(holidayThemes.Items || []).map((item, index) => (
                      <div className="holiday-theme-sec px-2" key={`${item.title}-${index}`}>
                        <div className="">
                          <a href={item.link_url || '/holidays-list'} target="_blank" rel="noreferrer">
                            <img src={item.image_url} width="100%" alt={item.title} />
                            <h5 className="holiday-theme-name">{item.title}</h5>
                          </a>
                        </div>
                      </div>
                    ))}
                  </Slider>
                  </div>
                ) : (
                  <div className="row">
                    {(holidayThemes.Items || []).map((item, index) => {
                      const pv = parseInt(holidayThemes.items_per_view) || 5;
                      const cw = 100 / pv;
                      return (
                      <div className="holiday-theme-sec holiday-by-theme-width-25" style={{ flex: `0 0 ${cw}%`, maxWidth: `${cw}%` }} key={`${item.title}-${index}`}>
                        <div className="">
                          <a href={item.link_url || '/holidays-list'} target="_blank" rel="noreferrer">
                            <img src={item.image_url} width="100%" alt={item.title} />
                            <h5 className="holiday-theme-name">{item.title}</h5>
                          </a>
                        </div>
                      </div>
                    )})}
                  </div>
                )}

                <div className="view_btn"><a href={holidayThemes.button_link || '/holidays-list'}> {holidayThemes.button_text || 'View All Offers'}</a></div>

              </div>
            </div>
          </div>
          )}


          {isSectionActive('outstation_cabs') && (
          <div className="outstation-cab pb-5 mb-3 holidays-left">
            <div className="container">
              <div className="cab_outstation">
                <div className="title title-text">
                  <h5>Upto 15% Discount</h5>
                  <h3>{homeOutstationCabs.title}</h3>
                  <p>{homeOutstationCabs.subtitle}</p>
                </div>
                <div className="cab-btn org-btn">
                  <a href="/cabs">Book Now</a>
                </div>

                {homeOutstationCabs?.is_slider ? (
                  <Slider 
                    slidesToShow={parseInt(homeOutstationCabs.items_per_view) || 4} 
                    slidesToScroll={1} 
                    autoplay={true} 
                    arrows={true}
                    responsive={[{breakpoint: 1024, settings: {slidesToShow: 3}}, {breakpoint: 768, settings: {slidesToShow: 1}}]}
                  >
                    {(homeOutstationCabs.Items || []).map((item, index) => (
                      <div className="px-2" key={index}>
                        {renderOutstationCabCard(item, 'ecpl_rbx cabs-city-to-city mx-auto', { width: '90%' })}
                      </div>
                    ))}
                  </Slider>
                ) : (
                  <div className="_polrdestnbx d-flex justify-content-space-between gap-15 flex-wrap">
                    {(homeOutstationCabs.Items || []).map((item, index) => {
                      return (
                        <Fragment key={index}>
                          {renderOutstationCabCard(item, 'ecpl_rbx cabs-city-to-city')}
                        </Fragment>
                    )})}
                  </div>
                )}

              </div>
            </div>
          </div>
          )}

          {isSectionActive('why_book') && (
          <section className="popular-state pb-5 mb-5">
            <div className="container">
              <div className="title text-center">
                <h3 className="pb-5"><span>Why book </span> with us?</h3>

                <div className="row">
                  {whyBookItems.map((item, index) => (
                      <div className="col-lg-3" key={`${item.title}-${index}`}>
                        <div className="why-us-home">
                          <div className="icon d-flex justify-content-center align-items-center">
                            <img src={item.image_url} alt={item.title} />
                          </div>
                          <div className="text">
                            <h5>{item.title}</h5>
                            <p>{item.description}</p>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>

              </div>
            </div>
          </section>
          )}

        </main>

        <Footer />
      </Fragment>
    </div>
  )
}

export default Index
